module.exports = __webpack_public_path__ + "img/WeChat.ab1c0e91.png";